/* Doelgroep-schakelaar Consument | Zakelijk (DIEK, okt 2026).
   1. Patcht FoxTheme.Currency.formatMoney zodat prijzen die de theme-JS zelf schrijft
      (bundel-variantkiezer, sticky add-to-cart, gratis-verzending-balk) de stand volgen.
   2. <vat-switcher>: zet html.vat-excl, onthoudt de keuze in localStorage en schrijft het
      cart-attribuut _audience (b2c|b2b), zodat de order laat zien hoe iemand winkelde.
   De stand zelf wordt vóór de eerste paint gezet in snippets/vat-mode.liquid. */
(function () {
  var KEY = 'bradas:vat';
  var root = document.documentElement;
  var syncedAudience = null;

  function isExcl() {
    return root.classList.contains('vat-excl');
  }
  function divisor() {
    var rate = parseFloat(root.dataset.vatRate || '21');
    return 1 + rate / 100;
  }

  function patchFormatMoney() {
    if (!window.FoxTheme || !FoxTheme.Currency || FoxTheme.Currency.__vatPatched) return;
    var original = FoxTheme.Currency.formatMoney;
    // Zelfde markup als snippets/vat-price.liquid: CSS toont incl. of excl. op basis van html.vat-excl,
    // dus ook prijzen die de theme-JS schrijft volgen een latere wissel. Zonder data-vat-rate (schakelaar uit) ongewijzigd.
    FoxTheme.Currency.formatMoney = function (cents, format) {
      if (!root.dataset.vatRate) return original.call(this, cents, format);
      var n = typeof cents === 'string' ? parseFloat(cents.replace('.', '')) : Number(cents);
      if (isNaN(n)) return original.call(this, cents, format);
      var incl = original.call(this, n, format);
      var excl = original.call(this, Math.round(n / divisor()), format);
      return '<span class="vat-price" data-vat-cents="' + n + '"><span class="vat-price__incl">' + incl + '</span><span class="vat-price__excl">' + excl + '</span></span>';
    };
    FoxTheme.Currency.__vatPatched = true;
  }
  patchFormatMoney();
  document.addEventListener('DOMContentLoaded', patchFormatMoney);

  /* Zakelijk zijpaneel (snippets/b2b-account-drawer.liquid): gedelegeerde klik op [data-b2b-drawer-trigger].
     Sleeks ModalComponent koppelt zijn controls alleen bij connectedCallback; dit vangnet werkt los daarvan.
     Zonder paneel in de DOM doet de link gewoon zijn href (account). */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-b2b-drawer-trigger]');
    if (!trigger) return;
    var drawer = document.getElementById('B2BDrawer');
    if (!drawer) return;
    event.preventDefault();
    if (typeof drawer.show === 'function') {
      if (drawer.hasAttribute('open')) drawer.hide(); else drawer.show(trigger);
    } else {
      /* Custom element nog niet geüpgraded: zet het attribuut; attributeChangedCallback doet de rest zodra hij er is. */
      drawer.hidden = false;
      drawer.setAttribute('open', '');
    }
    trigger.setAttribute('aria-expanded', drawer.hasAttribute('open') ? 'true' : 'false');
  });
  /* De triggers staan niet als aria-controls op het paneel (anders bindt Sleek ze ook en togglet een klik dubbel);
     sluit het paneel via overlay/kruisje/Escape, dan aria-expanded terugzetten. */
  document.addEventListener('drawer:handleAfterHide', function (event) {
    if (!event.target || event.target.id !== 'B2BDrawer') return;
    document.querySelectorAll('[data-b2b-drawer-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  });

  /* Stil falen: de schakelaar mag nooit breken op een netwerkfout. Zonder attribuut
     staat de order gewoon zonder _audience. */
  function syncCartAttribute() {
    var audience = isExcl() ? 'b2b' : 'b2c';
    if (audience === syncedAudience || !window.fetch) return;
    syncedAudience = audience;
    fetch(root.dataset.cartUpdateUrl || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _audience: audience } }),
    }).catch(function () {
      syncedAudience = null;
    });
  }

  function setMode(mode) {
    try { localStorage.setItem(KEY, mode); } catch (e) { /* private mode */ }
    root.classList.toggle('vat-excl', mode === 'excl');
    syncCartAttribute();
    document.dispatchEvent(new CustomEvent('vat:change', { detail: { mode: mode } }));
  }

  class VatSwitcher extends HTMLElement {
    connectedCallback() {
      this.modeButtons = Array.prototype.slice.call(this.querySelectorAll('[data-vat-mode]'));
      this.toggleButton = this.querySelector('[data-vat-toggle]');
      this.sync();
      this.addEventListener('click', this.onClick.bind(this));
      this.onChange = this.sync.bind(this);
      document.addEventListener('vat:change', this.onChange);
    }
    disconnectedCallback() {
      document.removeEventListener('vat:change', this.onChange);
    }
    onClick(event) {
      var modeButton = event.target.closest('[data-vat-mode]');
      if (modeButton) {
        var mode = modeButton.dataset.vatMode === 'excl' ? 'excl' : 'incl';
        if ((mode === 'excl') !== isExcl()) setMode(mode);
        return;
      }
      if (event.target.closest('[data-vat-toggle]')) setMode(isExcl() ? 'incl' : 'excl');
    }
    sync() {
      var excl = isExcl();
      this.modeButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', String((button.dataset.vatMode === 'excl') === excl));
      });
      if (this.toggleButton) this.toggleButton.setAttribute('aria-checked', String(excl));
    }
  }
  if (!customElements.get('vat-switcher')) customElements.define('vat-switcher', VatSwitcher);

  /* Referentieveld in de winkelwagen: schrijft het cart-attribuut (data-attribute) bij wijziging, debounced. */
  class CartAttributeField extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      if (!this.input) return;
      var self = this, timer = null;
      this.input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { self.save(); }, 500);
      });
      this.input.addEventListener('change', function () { clearTimeout(timer); self.save(); });
    }
    save() {
      var name = this.dataset.attribute || 'Referentie';
      var attributes = {}; attributes[name] = this.input.value.trim();
      if (!window.fetch) return;
      fetch(root.dataset.cartUpdateUrl || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes }),
      }).catch(function () { /* volgende wijziging probeert opnieuw */ });
    }
  }
  if (!customElements.get('cart-attribute-field')) customElements.define('cart-attribute-field', CartAttributeField);

  // Ook bij laden syncen: de cart kan later zijn ontstaan dan de keuze, of de stand komt uit de B2B-default.
  function start() {
    if (!root.dataset.vatSwitcher) return;
    syncedAudience = root.dataset.audience || null;
    var hasCart = root.classList.contains('cart-has-items');
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    if (hasCart || stored) syncCartAttribute();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
